import { render, staticRenderFns } from "./TabUpCulture.vue?vue&type=template&id=2097ab5b"
import script from "./TabUpCulture.vue?vue&type=script&lang=js"
export * from "./TabUpCulture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports